import { render } from "./client-fiscal.vue?vue&type=template&id=548dd3aa"
import script from "./client-fiscal.vue?vue&type=script&lang=js"
export * from "./client-fiscal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__